// BlockUiOverlay.js
import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import 'components/Expense/style.css';

const BlockUiOverlay = ({ visible }) => {
  return (
    <Backdrop open={visible} className="block-ui-overlay">
      <CircularProgress  style={{color:'white'}} / >
    </Backdrop>
  );
};

export default BlockUiOverlay;
